import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import { Button } from './ui/button';

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowBanner(false);
  };

  const declineCookies = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 shadow-lg">
      <div className="container mx-auto px-6 sm:px-8 lg:px-12 py-5">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="flex-1 pr-8">
            <p className="font-body text-[#334d6e] text-sm leading-relaxed">
              We use cookies to enhance your experience. By continuing to visit this site you agree to our use of cookies.
            </p>
          </div>
          <div className="flex items-center gap-3">
            <Button
              onClick={declineCookies}
              variant="ghost"
              data-testid="cookie-decline"
              className="font-body text-sm text-[#334d6e] hover:text-[#0D1B3E] hover:bg-transparent px-4 py-2"
            >
              Decline
            </Button>
            <Button
              onClick={acceptCookies}
              data-testid="cookie-accept"
              className="font-body text-sm bg-[#0D1B3E] hover:bg-[#1A3A6B] text-white px-6 py-2 rounded-none"
            >
              Accept
            </Button>
          </div>
          <button
            onClick={declineCookies}
            className="absolute top-3 right-4 sm:hidden text-gray-400 hover:text-gray-600"
          >
            <X size={18} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
